module.exports = __webpack_public_path__ + "img/fireplace_thumb.3fe3704c.jpg";